import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { translateServerLoaderFactory } from '../shared/loaders/translate-server.loader';
import { TransferState } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { TranslateDirectiveModule } from '@src/app/core/shared/directives/translate.directive.module';
import { TranslateItModule } from '@src/app/core/shared/pipes/translate-it/translate-it.module';

export const COMMON_MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  TranslateModule,
  TranslateDirectiveModule,
  TranslateItModule
];

export const ROOT_LEVEL_MODULES = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: translateServerLoaderFactory,
      deps: [TransferState],
    },
  }),
  ToastrModule.forRoot({
    // preventDuplicates: true,
    // autoDismiss: true,
    // enableHtml: true,
    // closeButton: true,
    // maxOpened: 1,
    // resetTimeoutOnDuplicate: true,
    // progressBar: false,
    // timeOut: 10 * 1000, // 15 milliseconds
    // positionClass: 'toast-top-center',
    // disableTimeOut: false,
    // toastClass: 'wow-toastr',
    // messageClass: 'wow-toastr-text',
    // tapToDismiss: true,
  }),
];
